import { Component, HostListener } from '@angular/core';

// Providers
import { SecurityService } from '@core/providers/services/security/security.service';

//NgRX
import { Store } from '@ngrx/store';
import { AppState } from '@core/store/reducers';



@Component({
  selector: 'rental-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  constructor(
    private securityService: SecurityService,
    private readonly store: Store<AppState>
  ) { }


  @HostListener('document:click')
  @HostListener('document:keydown')
  // @HostListener('document:wheel')
  private restartLogoutTimeout(): void {
    // TO-DO: Store Action
    // this.store.dispatch();
    this.securityService.restartLogoutTimeout();
  }
}
